<template>
  <div class="results-list__item__price">
    <div
      class="results-list__item__price__wrapper is-flex-direction-column is-flex"
      v-if="lowestOffer"
    >
      <span
        class="is-flex is-align-items-center is-justify-content-center u-font-size--normal u-weight--bold"
      >
        <template v-if="nights === 1">
          {{ toPriceLabel(lowestOffer.price) }}
        </template>
        <template v-else>
          {{ getPricePerNight(lowestOffer) }}
        </template>
        <i
          v-if="isOverBudget"
          class="fa-solid fa-triangle-exclamation ml-1 js-tooltip u-text-color-orange"
          data-tooltip-position="top"
          :data-tooltip-content="$t('warningOverBudget', { budget })"
        ></i>
        <div
          v-if="offerPricingTooltip"
          class="c-icon-info c-icon-info--border js-tooltip is-inline-block"
          data-tooltip-position="top"
          :data-tooltip-content="offerPricingTooltip"
        ></div>
      </span>
      <sub v-if="nights > 1"
        >{{ $t("total") }} {{ toPriceLabel(lowestOffer.price) }} <br
      /></sub>
      <div class="price-label__icons mt-3">
        <img
          src="@/assets/images/icons/refund.svg"
          class="pr-3 js-tooltip"
          :class="{
            nonAvailable: !lowestOffer.isRefundable
          }"
          data-tooltip-position="top"
          :data-tooltip-content="
            lowestOffer.isRefundable
              ? $t('offerIsRefundable')
              : $t('offerIsNotRefundable')
          "
        />
        <img
          src="@/assets/images/icons/breakfast.svg"
          class="pr-3 js-tooltip"
          :class="{
            nonAvailable: !lowestOffer.isBreakfastIncluded
          }"
          data-tooltip-position="top"
          :data-tooltip-content="
            lowestOffer.isBreakfastIncluded
              ? $t('breakfastAvailable')
              : $t('breakfastNotAvailable')
          "
        />
      </div>
    </div>
    <div class="buttons has-addons is-flex-wrap-nowrap" style="width: 100%">
      <DebugInspector :data="hotel.suppliers" label="All Offers" :deep="99">
        <a
          class="c-button--small c-button--primary c-button--no-wrap"
          :href="hotelLink"
          @click.prevent="gotoHotelDetail"
          >{{ $t("viewHotel") }}</a
        >
      </DebugInspector>
    </div>
  </div>
</template>

<script>
import HotelHelper from "@/helpers/hotel.helper.js";
import CommonHelper from "@/helpers/common.helper.js";
import DebugInspector from "@/components/shared/DebugInspector.vue";

export default {
  name: "PriceLabel",
  components: { DebugInspector },
  methods: {
    getPricePerNight(offer) {
      return HotelHelper.getPricePerNight(offer, this.nights);
    },
    gotoHotelDetail() {
      this.$emit("gotoDetail");
    }
  },
  async created() {
    const companyInfo = await CommonHelper.getCompanyInfo();
    this.companyInfo = companyInfo;
    this.budget = companyInfo.budget;
  },
  data() {
    return {
      budget: null,
      companyInfo: null
    };
  },
  computed: {
    isDirectBooking() {
      return HotelHelper.isDirectBookingOffer(this.lowestOffer);
    },
    isOverBudget() {
      if (!this.budget || this.budget == null) {
        return false;
      }
      const pricePerNight = HotelHelper.getBarePricePerNight(
        this.lowestOffer,
        this.nights
      );
      return pricePerNight > this.budget;
    },
    pricePerNight() {
      if (this.nights == 1) {
        return this.lowestOffer.price;
      } else {
        return this.getPricePerNight(this.lowestOffer);
      }
    },
    offerPricingTooltip() {
      return HotelHelper.getOfferPricingText(this.hotel, this.$i18n);
    }
  },
  watch: {
    "hotel.suppliers": {
      handler() {
        this.lowestOffer = HotelHelper.getComparisonDisplayOffer(this.hotel);
      },
      immediate: true
    }
  },
  props: {
    hotel: {},
    hotelLink: {
      type: String,
      default: null
    },
    // REFACTOR_CHECK: Consider using a single link prop instead of hotelLink and reservationLink, maybe remove the link entirely and use the hotel object to generate the link in the parent component.
    reservationLink: {
      type: String,
      default: null
    },
    adults: String,
    rooms: String,
    nights: [String, Number]
  }
};
</script>
